import { GetStaticPaths } from "next"

import { ContentPage } from "src/components/pages/ContentPage"

import { getCMSPathSlugs } from "src/helpers/getPathSlugs"
import { getStaticProps } from "src/helpers/getStaticProps"

import { FALLBACK } from "src/helpers/slug"

export { getStaticProps }

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = await getCMSPathSlugs()
  return {
    paths: paths,
    fallback: FALLBACK,
  }
}

export default ContentPage
